import React, { Component } from 'react';
import classNames from 'classnames';

import './styles.scss';

interface CardProps {
    cardTextHeader?: string;
    cardTextMessage?: string;
    isError?: boolean;
}

class CardComponent extends Component<CardProps> {
    render() {
        return (
            <div className={classNames('comp-card-container', { 'error-container': this.props.isError })}>
                <div className="recruiter-card-content-container">
                    <div className="recruiter-info-container">
                        <div>
                            <div className="recruiter-name">Candidate Portal</div>
                        </div>
                    </div>

                    {this.props?.cardTextHeader ? (
                        <div className="request-header">{this.props?.cardTextHeader}</div>
                    ) : null}
                    {this.props?.cardTextMessage ? (
                        <div className={classNames('request-sub-header', { 'error-message': this.props?.isError })}>
                            {this.props?.cardTextMessage}
                        </div>
                    ) : null}
                </div>

                <div className="comp-recruiter-button-container"></div>
            </div>
        );
    }
}

export default CardComponent;
